import request from '../utils/request'

// 获取文章列表
export function getContentList(params) {
  return request({
    url: '/index/website/content',
    method: 'get',
    params
  })
}

// 获取文章详情
export function getContentDetail(contentId) {
  return request({
    url: '/index/website/content/detail/' + contentId,
    method: 'get'
  })
}

// 获取最新的文章
export function getRecentContent(contentId) {
  return request({
    url: '/index/website/recent/content/' + contentId,
    method: 'get'
  })
}

// 获取短信验证码
export function getSmsCode(params) {
  return request({
    url: '/index/getSmsCode',
    method: 'get',
    params
  })
}

// 验证验证码
export function checkCode(data) {
  return request({
    url: '/index/reserveProduct/checkCode',
    method: 'post',
    data
  })
}

// 提交预约演示表单数据
export function submitFormData(data) {
  return request({
    url: 'http://120.76.77.155:8055/huayue/AddYYYS',
    method: 'post',
    data
  })
}

// 查询
export function search(data) {
  return request({
    url: 'http://120.76.77.155:8055/Tech/search',
    method: 'post',
    data
  })
}

// 获取最新5文章
export function GetTotal() {
  return request({
    url: 'http://120.76.77.155:8055/Tech/GetTotal2',
    method: 'Get'
  })
}

export function submitForm(data) {
  return request({
    url: '/index/website/form/data',
    method: 'post',
    data
  })
}

// 下载附件
export function download(id) {
  return request({
    url: '/resource/download/' + id,
    method: 'get',
    responseType: 'blob'
  })
}
